import { Component, Vue } from 'vue-property-decorator';
import WithRender from './users.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import { UserType } from '@/types/users.types';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  },
})
export default class Users extends Vue {
  username = "";
  exact = "";
  busy = false;
  processing = false;
  userDetails = {} as UserType;

  items = [];
  fields = [
    {
      key: "userName",
    },
    {
      key: "agentCode",
    },
    {
      key: "fullName",
    },
    {
      key: "email",
    },
    {
      key: "whatsApp",
    },
    {
      key: "balance",
    },
    {
      key: "creditBalance",
    },
    {
      key: "commissionBalance",
    },
    {
      key: "isCommissionWallet",
    },
    {
      key: "createdOn",
      label: "Time",
    },
    {
      key: "id",
      label: ""
    }
  ]


  async onSearch() {
    try {
      this.busy = true;
      this.processing = true;
      const response = await _axios.get(`${config.gateway}admin/User?username=${this.username}&search=${this.exact}`);
      this.items = response.data;
    } catch (error) {
      this.$bvToast.toast(error.response.data, {
        title: 'Notification',
        variant: 'danger',
        autoHideDelay: 5000,
      });
    }finally
    {
      this.busy = false;
      this.processing = false;
    }
  }
}
